/**
 * Central de Projetos (ADR-0089): rotas em /central-projetos/*.
 *
 * Painel, ficha do cliente, pendências, conversas do WhatsApp, Assistente e
 * configuração. A entrada exige `central_projetos:view` (App.jsx); cada tela
 * confere a permissão própria. Com a Central desligada, as telas mostram o
 * aviso e só a configuração funciona.
 */
import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import { useAuth } from "../../context/AuthContext";
import Assistente from "./Assistente";
import { PERM } from "./comum";
import Configuracao from "./Configuracao";
import Conversas from "./Conversas";
import Ficha from "./Ficha";
import Painel from "./Painel";
import Pendencias from "./Pendencias";

function SoCom({ permissao, children }) {
  const { hasPermission } = useAuth();
  return hasPermission?.(permissao) ? children : <Navigate to="/central-projetos" replace />;
}

export default function CentralProjetos() {
  return (
    <Routes>
      <Route index element={<Painel />} />
      <Route path="clientes/:pedido" element={<Ficha />} />
      <Route path="pendencias" element={<Pendencias />} />
      <Route path="conversas" element={<Conversas />} />
      <Route path="conversas/:conversaId" element={<Conversas />} />
      <Route path="assistente" element={<SoCom permissao={PERM.ASSISTENTE}><Assistente /></SoCom>} />
      <Route path="assistente/:conversaId" element={<SoCom permissao={PERM.ASSISTENTE}><Assistente /></SoCom>} />
      <Route path="configuracao" element={<SoCom permissao={PERM.CONFIGURAR}><Configuracao /></SoCom>} />
      <Route path="*" element={<Navigate to="/central-projetos" replace />} />
    </Routes>
  );
}
